import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  CircularProgress,
  Typography,
} from "@mui/material";

const AddNotes = ({
  open,
  onClose,
  candidatoId,
  onSave,
  contenidoInfo,
  isEditMode,
  noteId,
}) => {
  const [contenido, setContenido] = useState(isEditMode ? contenidoInfo : "");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    isEditMode ? setContenido(contenidoInfo) : setContenido("");
  }, [open]);

  const handleSubmit = async () => {
    const contenidoFinal = contenido.trim();

    if (contenidoFinal.length < 10) {
      setError("La nota debe tener al menos 10 caracteres.");
      return;
    }

    if (contenidoFinal.length > 1000) {
      setError("La nota no puede superar los 1000 caracteres.");
      return;
    }

    setError(null);
    setLoading(true);

    try {
      const user = localStorage.getItem("user") || "Anónimo";

      await onSave({
        candidatoId,
        contenido: contenidoFinal,
        user,
        noteId: isEditMode ? noteId : undefined,
      });

      setContenido("");
      onClose();
    } catch (e) {
      setError("Error al guardar la nota, intenta de nuevo");
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    if (!loading) {
      setContenido("");
      setError(null);
      onClose();
    }
  };

  const handleChangeContent = (e) => {
    const valor = e.target.value;
    setContenido(valor);

    if (valor.trim().length < 10) {
      setError("La nota debe tener al menos 10 caracteres.");
    } else if (valor.trim().length > 1000) {
      setError("La nota no puede superar los 1000 caracteres.");
    } else {
      setError("");
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>{isEditMode ? "Editar Nota" : "Agregar Nota"}</DialogTitle>
      <DialogContent dividers>
        <Box sx={{ mt: 1 }}>
          <TextField
            multiline
            fullWidth
            minRows={4}
            label="Escribí la nota"
            value={contenido}
            onChange={handleChangeContent}
            error={!!error}
            helperText={error}
          />
          {error && (
            <Typography color="error" sx={{ mt: 1 }}>
              {error}
            </Typography>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={loading} color="error">
          Volver
        </Button>
        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={
            loading ||
            contenido.trim().length < 10 ||
            contenido.trim().length > 1000
          }
          startIcon={loading ? <CircularProgress size={18} /> : null}
        >
          {isEditMode ? "Actualizar" : "Guardar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddNotes;
